module.exports = __webpack_public_path__ + "b8d456d318e15d1f31755ce70202b121.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/desktop_newsletter_bg_h365.png
// module id = 240
// module chunks = 0